'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _arrayAsObj = require('shared/utils/arrayAsObj');

var _arrayAsObj2 = _interopRequireDefault(_arrayAsObj);

var _getAvg = require('shared/utils/getAvg');

var _getAvg2 = _interopRequireDefault(_getAvg);

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

var _getValues = require('./getValues');

var _getValues2 = _interopRequireDefault(_getValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const MAX_SCALE = 1; //0-1
// const getMax = values => values.length * MAX_SCALE;
var getMax = function getMax(constants) {
  return constants.USER_AND_JOB_SKILL_MATCH_BOOST;
};

var getSkills = function getSkills(jobSkills, userSkillsArr, skillsArr, constants) {
  //const skills = objAsArray(skillsObj);
  var userSkills = (0, _arrayAsObj2.default)(userSkillsArr);
  //const jobSkills = arrayAsObj(jobSkillsArr);

  var skills = (0, _objAsArray2.default)(skillsArr.reduce(function (obj, skill) {
    var id = skill.id;

    if (userSkills[id] || jobSkills[id]) {
      return (0, _extends4.default)({}, obj, (0, _defineProperty3.default)({}, id, skill));
    }

    return obj;
  }, {}));

  var values = (0, _getValues2.default)(skills, userSkills, jobSkills, constants);

  var avg = (0, _getAvg2.default)(values, (0, _keys2.default)(jobSkills).length);

  var skillMatch = avg / getMax(constants);

  return skillMatch < 0 ? 0 : skillMatch;
};

exports.default = getSkills;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/skills/getSkills.js
// module id = 1318
// module chunks = 0